import * as React from 'react';
import { Box, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

function DateRangePicker({
  value = [null, null],
  onChange,
  name,
  enableTimeSelection,
}) {
  const [start, end] = value.map(v => (v ? dayjs(v) : null));

  const sendAsTargetValue = newValue => ({
    target: { name, value: newValue },
  });

  const handleStartChange = newValue => {
    onChange(sendAsTargetValue([newValue || null, value[1] || null]));
  };

  const handleEndChange = newValue => {
    onChange(sendAsTargetValue([value[0] || null, newValue || null]));
  };

  const FieldPicker = enableTimeSelection ? DateTimePicker : DatePicker;

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      <Stack direction="row" spacing={2}>
        <FieldPicker
          value={start}
          onChange={handleStartChange}
          slotProps={{
            textField: { size: 'small', fullWidth: true },
            field: {
              clearable: true,
              onClear: () => handleStartChange(null),
            },
          }}
        />
        <FieldPicker
          value={end}
          onChange={handleEndChange}
          slotProps={{
            textField: { size: 'small', fullWidth: true },
            field: {
              clearable: true,
              onClear: () => handleEndChange(null),
            },
          }}
        />
      </Stack>
    </Box>
  );
}

export default DateRangePicker;
